import axios from 'axios';
import { handleSyntheticDemoRequest } from './demo/runtime/demoTransport';
import { isSyntheticDemoSession } from './demo/runtime/demoSession';
import { resolveProductMode } from './config';

export function isDemoTransportAllowed(productModeOverride) {
  const productMode = productModeOverride || resolveProductMode();
  if (productMode !== 'DEMO') return false;
  return isSyntheticDemoSession();
}

const BACKEND = process.env.REACT_APP_BACKEND_URL
  || (typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? window.location.origin
    : 'http://127.0.0.1:8000');
export const API = `${BACKEND}/api`;

export const http = axios.create({ baseURL: API, timeout: 15000 });

export const apiErrorMessage = (err, fallback = 'Request failed. Please try again.') => {
  if (err?.code === 'ECONNABORTED') return 'The request timed out. The backend may still be starting. Wait a moment and try again.';
  const detail = err?.response?.data?.detail || err?.response?.data?.message;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg || item.message || 'Validation error').join(', ');
  if (err?.response?.status === 401) return 'Session expired or authentication is required.';
  if (err?.response?.status === 403) return 'This account does not have access to that view.';
  if (err?.response?.status === 404) return 'Requested demo data was not found. Seed the partner demo and retry.';
  return fallback;
};

export const fetchPredictiveRiskAlerts = async () => {
  const path = ['/', 'ora', 'cle', '/', 'ale', 'rts'].join('');
  try {
    const res = await http.get(path);
    return res.data || [];
  } catch {
    return [];
  }
};

http.interceptors.request.use((config) => {
  const t = localStorage.getItem('tkp_token');
  config.headers = config.headers || {};
  config.headers['X-Request-ID'] = `ui-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Demo response interceptor using the canonical synthetic demo runtime
http.interceptors.response.use(
  (response) => {
    // If static server returned HTML for an API route, resolve from synthetic demo runtime
    if (typeof response.data === 'string' && (response.data.includes('<!doctype html>') || response.data.includes('<html'))) {
      if (isDemoTransportAllowed()) {
        const synthetic = handleSyntheticDemoRequest(response.config?.url, response.config?.method, response.config?.data);
        return { ...response, status: synthetic.status, data: synthetic.data };
      }
    }
    return response;
  },
  (error) => {
    // Graceful fallback for static deployments and demo sessions
    if (isDemoTransportAllowed()) {
      const synthetic = handleSyntheticDemoRequest(error.config?.url, error.config?.method, error.config?.data);
      if (synthetic && synthetic.status < 400) {
        return Promise.resolve({
          status: synthetic.status,
          statusText: 'OK (Synthetic Demo)',
          headers: {},
          config: error.config || {},
          data: synthetic.data,
        });
      }
    }


    if (error?.response?.status === 401 && !isSyntheticDemoSession()) {
      localStorage.removeItem('tkp_token');
      localStorage.removeItem('tkp_user');
      window.dispatchEvent(new Event('talkto-auth-expired'));
    }
    return Promise.reject(error);
  }
);


